import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import czechTexts from "./locales/cs-CZ.json";
import danishTexts from "./locales/da-DK.json";
import germanTexts from "./locales/de-DE.json";
import greekTexts from "./locales/el-GR.json";
import englishTexts from "./locales/en-EU.json";
import finnishTexts from "./locales/fi-FI.json";
import frenchTexts from "./locales/fr-FR.json";
import hungarianTexts from "./locales/hu-HU.json";
import italianTexts from "./locales/it-IT.json";
import japaneseTexts from "./locales/ja-JP.json";
import dutchTexts from "./locales/nl-NL.json";
import norwegianTexts from "./locales/no-NO.json";
import polishTexts from "./locales/pl-PL.json";
import portugueseTexts from "./locales/pt-PT.json";
import slovakTexts from "./locales/sk-SK.json";
import romanianTexts from "./locales/ro-RO.json";
import spanishTexts from "./locales/es-ES.json";
import swedishTexts from "./locales/sv-SE.json";
import serbianTexts from "./locales/sr-RS.json";
import turkishTexts from "./locales/tr-TR.json";
import ukrainianTexts from "./locales/uk-UA.json";
import hebrewTexts from "./locales/he-IL.json";
import arabicTexts from "./locales/ar-001.json";

i18n.use(initReactI18next).init({
    resources: {
        "en-EU": {
            translation: englishTexts,
        },
        "sv-SE": {
            translation: swedishTexts,
        },
        "de-DE": {
            translation: germanTexts,
        },
        "da-DK": {
            translation: danishTexts,
        },
        "nl-NL": {
            translation: dutchTexts,
        },
        "tr-TR": {
            translation: turkishTexts,
        },
        "no-NO": {
            translation: norwegianTexts,
        },
        "pt-PT": {
            translation: portugueseTexts,
        },
        "fi-FI": {
            translation: finnishTexts,
        },
        "fr-FR": {
            translation: frenchTexts,
        },
        "pl-PL": {
            translation: polishTexts,
        },
        "el-GR": {
            translation: greekTexts,
        },
        "ja-JP": {
            translation: japaneseTexts,
        },
        "cs-CZ": {
            translation: czechTexts,
        },
        "hu-HU": {
            translation: hungarianTexts,
        },
        "it-IT": {
            translation: italianTexts,
        },
        "es-ES": {
            translation: spanishTexts,
        },
        "ro-RO": {
            translation: romanianTexts,
        },
        "sk-SK": {
            translation: slovakTexts,
        },
        "sr-RS": {
            translation: serbianTexts,
        },
        "uk-UA": {
            translation: ukrainianTexts,
        },
        "he-IL": {
            translation: hebrewTexts,
        },
        "ar-001": {
            translation: arabicTexts,
        },
    },
    lng: "en-EU",
    fallbackLng: "en-EU",
    interpolation: {
        escapeValue: false,
    },
});
